<template>
   <el-dialog custom-class="dialog-wrapper" :title="dialogTitle" :close-on-click-modal="false"
      :modal-append-to-body="false" :visible.sync="dialogVisible" width="600px">
      <div class="form-wrapper">
         <el-form label-width="180px" label-position="left" :model="formData" ref="formRef">
            <el-form-item label="校区范围">
               <el-radio-group v-model="formData.isAll">
                  <el-radio :label="1">全量</el-radio>
                  <el-radio :label="0">部分</el-radio>
               </el-radio-group>
            </el-form-item>
            <el-form-item :label="campusSelectLabel">
               <el-select style="width: 100%" placeholder="请选择校区" v-model="formData.campusList" multiple filterable>
                  <el-option v-for="(item, index) in campusDataSource" :key="index"
                     :label="item.label + '（' + item.value + '）'" :value="item.value"></el-option>
               </el-select>
               <div class="card-footer">
                  共计{{ formData.campusList.length }}个校区
               </div>
            </el-form-item>
         </el-form>
      </div>
      <div slot="footer">
         <div class="flex-row-center">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="clickSave">确定</el-button>
         </div>
      </div>
   </el-dialog>
</template>

<script>
export default {
   name: 'PhysicalReportCampusShield',
   props: {
      dialogTitle: {
         type: String,
         default: ''
      },
      dataSource: {
         type: Object,
         default: () => ({})
      },
      campusDataSource: {
         type: Array,
         default: () => []
      }
   },
   data() {
      return {
         dialogVisible: false,
         formData: {
            isAll: 1,
            campusList: []
         }
      }
   },
   computed: {
      campusSelectLabel() {
         return Number(this.formData.isAll) === 1 ? '屏蔽校区选择' : '生效校区选择';
      }
   },
   methods: {
      // 显示编辑对话框
      clickEdit() {
         this.dialogVisible = true;
         this.initFormData();
      },
      // 初始化表单数据
      initFormData() {
         this.formData.isAll = 1;
         this.formData.campusList = [];
         const resValue = this.dataSource && this.dataSource.resValue;
         if (!resValue || resValue === '') {
            return;
         }
         try {
            const data = JSON.parse(resValue);
            this.formData.isAll = Number(data.isAll) === 0 ? 0 : 1;
            const unids = Array.isArray(data.unids) ? data.unids : [];
            const campusList = [];
            unids.forEach((unid) => {
               const idStr = String(unid);
               const campusData = this.campusDataSource.find((item) =>
                  String(item.value) === idStr
               );
               if (campusData) {
                  campusList.push(campusData.value);
               }
            });
            this.formData.campusList = campusList;
         } catch (error) {
            console.log('学生端体测报告配置-解析数据失败:', error);
            this.formData.campusList = [];
         }
      },
      // 保存
      clickSave() {
         const unids = this.formData.campusList.map((item) => {
            return typeof item === 'number' ? item : Number(item);
         });

         const param = {
            tag: this.dataSource.tag,
            key: this.dataSource.resKey,
            value: JSON.stringify({
               isAll: Number(this.formData.isAll),
               unids: unids
            })
         };

         this.$http({
            url: this.$util.domain + "/adminapi/v1/tools/addOrUpdateConfig",
            method: "POST",
            dataType: "json",
            body: JSON.stringify(param)
         }).then((res) => {
            if (res.body && res.body.error === 10000) {
               this.$util.successMsg('保存成功');
               this.handleClose();
               this.$emit('refresh');
            } else {
               this.$util.errorMsg((res.body && res.body.message) || '保存失败');
            }
         }).catch((error) => {
            console.log('学生端体测报告配置-保存失败:', error);
            this.$util.errorMsg('保存失败');
         });
      },
      // 关闭对话框
      handleClose() {
         this.dialogVisible = false;
         this.formData.campusList = [];
         this.formData.isAll = 1;
      }
   }
}
</script>

<style scoped>
.card-footer {
   text-align: right;
   font-size: 14px;
   line-height: 1.5;
}

.flex-row-center {
   display: flex;
   justify-content: center;
   align-items: center;
}
</style>



// WEBPACK FOOTER //
// PhysicalReportCampusShield.vue?f0783f74